import { createContext, useState } from "react";

export const AccountContext = createContext();
const AccountProvider = ({children}) =>{
    const [showNewServerConnectionWindow,setShowNewServerConnectionWindow] = useState(false);
    const [selectedEditSystemAdminProfile,setSelectedEditSystemAdminProfile] = useState(null);
    const [selectedDeleteSystemAdminProfile,setSelectedDeleteSystemAdminProfile] = useState(null);
    return(
        <AccountContext.Provider value={{
            showNewServerConnectionWindow,
            setShowNewServerConnectionWindow,
            selectedEditSystemAdminProfile,
            setSelectedEditSystemAdminProfile,
            selectedDeleteSystemAdminProfile,
            setSelectedDeleteSystemAdminProfile
        }}>{children}</AccountContext.Provider>
    );
};
export default AccountProvider;